import { put, takeLatest } from 'redux-saga/effects'

import * as uploadedFilesModule from '../reducks/uploadedFiles'

import * as uploadedFilesApi from '../apiModules/uploadedFiles'

function* createUploadedFileSaga(action) {
  try {
    const response = yield uploadedFilesApi.createUploadedFile(action.payload.id, action.payload.data)
    yield put(
      uploadedFilesModule.createUploadedFileSuccess({
        ...response,
        editing: true,
      }),
    )
  } catch (error) {}
}

function* fetchUploadedFilesSaga(action) {
  try {
    const response = yield uploadedFilesApi.fetchUploadedFiles(action.payload.id)
    yield put(uploadedFilesModule.fetchUploadedFilesSuccess(response))
  } catch (error) {}
}

function* deleteUploadedFilesSaga(action) {
  try {
    yield uploadedFilesApi.deleteUploadedFile(action.payload.id)
    yield put(uploadedFilesModule.fetchUploadedFiles(action.payload.candidate_id))
  } catch (error) {}
}

export default function* watchUploadedFilesSaga() {
  yield takeLatest(uploadedFilesModule.CREATE, createUploadedFileSaga)
  yield takeLatest(uploadedFilesModule.FETCH, fetchUploadedFilesSaga)
  yield takeLatest(uploadedFilesModule.DELETE, deleteUploadedFilesSaga)
}
